import React from "react";
import { Search, X } from "lucide-react";

/** Horizontal container for filter controls + active-filter chips. */
export function FilterBar({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-sm mb-md">{children}</div>
  );
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  return (
    <label className="flex items-center gap-xs px-sm h-9 rounded-md bg-surface border border-border focus-within:border-brand/40 transition-colors">
      <Search size={14} className="text-textLight" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="bg-transparent text-sm outline-none placeholder:text-textLight w-44"
      />
    </label>
  );
}

export function FilterSelect({
  value,
  onChange,
  options,
  label,
}: {
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  label?: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={label}
      className="h-9 px-sm rounded-md bg-surface border border-border text-sm text-text cursor-pointer"
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}

export function FilterChip({ label, onClear }: { label: string; onClear: () => void }) {
  return (
    <span className="inline-flex items-center gap-xs px-sm py-[3px] rounded-full text-xs bg-brand/10 text-brand">
      {label}
      <button type="button" onClick={onClear} className="hover:text-brand-dark cursor-pointer">
        <X size={12} />
      </button>
    </span>
  );
}
